// This icon file is generated automatically.
var PPlusOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M5.53.38h.94c.08 0 .12.04.12.12v11c0 .08-.04.13-.12.13h-.94c-.08 0-.12-.05-.12-.13V.5c0-.08.04-.13.12-.13zM.75 5.4h10.5c.08 0 .13.04.13.12v.94c0 .08-.05.12-.13.12H.75c-.08 0-.13-.04-.13-.12v-.94c0-.08.05-.12.13-.12z", "fill-rule": "nonzero" } }] }, "name": "p-plus", "theme": "outlined" };
export default PPlusOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PPlusOutlined.js
// module id = 3542
// module chunks = 0